import { useState } from "react";
import DefaultModal from "components/modals/ModalTemplate";
import {
    DISABLE_GATEWAY_EVENT_MESSAGE,
    DISABLE_GATEWAY_EVENT_TITLE,
} from "constant/index";

type GatewayEventLike = {
    activate?: boolean;
    gateway_id?: string | null;
};

export const useDisableGatewayEventConfirm = () => {
    const [show, setShow] = useState(false);
    const [pendingAction, setPendingAction] = useState<(() => void) | null>(
        null
    );

    const confirmIfNeeded = (
        event: GatewayEventLike,
        action: () => void
    ) => {
        if (event.activate && event.gateway_id) {
            setPendingAction(() => action);
            setShow(true);
            return;
        }
        action();
    };

    const disableConfirmModal = (
        <DefaultModal
            modalShow={show}
            setModalShow={setShow}
            modalType="disableConfirm"
            modalTitle={DISABLE_GATEWAY_EVENT_TITLE}
            modalContent={DISABLE_GATEWAY_EVENT_MESSAGE}
            resendFunction={() => {
                pendingAction?.();
                setPendingAction(null);
            }}
        />
    );

    return { confirmIfNeeded, disableConfirmModal };
};
